<template>
  <block>
    <div v-if="product" class="main-container">
      <alert
        v-if="hasEnded"
        class="margin-2xl-bottom"
        theme="warning"
        title="justopp.deal.expiredTitle"
        content="justopp.deal.expiredExplain"></alert>
      <div class="top-block flex-wrap l:flex-no-wrap flex-between gap-max">
        <div class="content width-expand">
          <div class="title">
            <h2 class="h1 margin-s-bottom">{{ product?.name }} - {{ product.code }}</h2>
            <p class="">{{ product?.shortIntroText }}</p>
            <hr
              class="margin-l-vertical max-width-400"
              style="margin-inline-end: auto; margin-inline-start: 0" />
          </div>
          <!-- todo: try option where prices live with the title, and the short description lives with the purchase UI-->
          <div class="purchase-ui">
            <div class="deal-data width-expand bg-gray-1 padding-m">
              <div class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.productCode") }}:&nbsp
                </strong>
                <span>{{ product.code }}</span>
              </div>
              <div class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.barcode") }}:&nbsp
                </strong>
                <span>{{ product.barcode }}</span>
              </div>
              <div class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.price") }}:&nbsp
                </strong>
                <span>
                  {{
                    translateNumber(product.price, "currency", {
                      currency: product.currency,
                    })
                  }}
                  / {{ translateUcFirst("justopp.deal.unit") }}
                </span>
              </div>
              <!--
              <div class="item">
                <strong class="inline-block" style="width: 170">
                  {{ translateUcFirst("justopp.deal.startingBid") }}:&nbsp
                </strong>
                <span>
                  {{
                    translateNumber(
                      product.AuctionProductType.startingPrice,
                      "currency",
                      {
                        currency: product.currency,
                      }
                    )
                  }}
                  / {{ translateUcFirst("justopp.deal.unit") }} -
                  {{
                    translateNumber(
                      product.AuctionProductType.startingPrice * quantity,
                      "currency",
                      {
                        currency: product.currency,
                      }
                    )
                  }}
                  {{ translateUcFirst("justopp.deal.total") }}.
                </span>
              </div>
              -->
              <div class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.minimumBid") }}:&nbsp
                </strong>
                <span v-if="isBiddingEnabled && minimumBid <= product.price">
                  {{
                    translateNumber(minimumBid, "currency", {
                      currency: product.currency,
                    })
                  }}
                  / {{ translateUcFirst("justopp.deal.unit") }}
                </span>
                <span v-else="">N/A</span>
              </div>
              <div class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.availableUnits") }}:&nbsp
                </strong>
                <span>{{
                  translateNumber(product.JustoppDealProductType.maximumQuantity)
                }}</span>
              </div>
              <div class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.minimumUnits") }}:&nbsp
                </strong>
                <span>{{
                  translateNumber(product.JustoppDealProductType.minimumQuantity)
                }}</span>
              </div>
              <div v-if="!hasEnded" class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.expires") }}:&nbsp
                </strong>
                <span
                  >{{ translateDate(product.AuctionProductType.endDateTime, "long") }}
                </span>
              </div>
              <div class="item">
                <strong class="inline-block" style="width: 170px">
                  {{ translateUcFirst("justopp.deal.originWarehouseCountry") }}:&nbsp
                </strong>

                <span v-if="product.JustoppDealProductType.warehouseCountry">{{
                  product.JustoppDealProductType.warehouseCountry !== ""
                    ? product.JustoppDealProductType.warehouseCountry
                    : "-"
                }}</span>
                <span v-else="">{{
                  product.JustoppDealProductType.originWarehouse !== ""
                    ? product.JustoppDealProductType.originWarehouse
                    : "-"
                }}</span>
              </div>
            </div>

            <div
              v-if="!hasEnded"
              class="buy-controls flex gap-m flex-wrap margin-xl-top margin-l-bottom">
              <div class="buy-now-controls">
                <div class="controls-block flex flex-bottom gap-s">
                  <div class="quantity-control">
                    <form-input
                      v-model="quantity"
                      class="quantity-controls max-width-150"
                      type="justoppUnits"
                      label="justopp.deal.selectQuantity"
                      :step-size="product.JustoppDealProductType.minimumQuantity"
                      :minimum="product.JustoppDealProductType.minimumQuantity"
                      :maximum="
                        product.JustoppDealProductType.maximumQuantity
                      "></form-input>
                  </div>
                </div>
              </div>
              <div
                class="separator bg-gray s:visible"
                style="
                  height: 40px;
                  min-width: 2px;
                  flex: 0 0 2px;
                  margin-top: 1.5em;
                "></div>
              <div class="bid-button-controls button-control relative">
                <div class="buy-now-cta">
                  <form-button
                    icon="cart-plus"
                    theme="lead"
                    @click="beginProductOrder('standard')">
                    {{ translateUcFirst("justopp.deal.buyNow") }}
                  </form-button>
                </div>
                <div class="bid-controls">
                  <block v-if="isBiddingEnabled" class="flex">
                    <form-button
                      :disabled="isUserWinningTheBid || minimumBid == product.price"
                      icon="cart-plus"
                      theme="alt"
                      @click="isShowingBidPlacer = true"
                      >{{ translateUcFirst("justopp.deal.placeBid") }}</form-button
                    >
                  </block>
                  <div v-if="userHasBid" class="current-bid">
                    <strong style="min-width: 150px"
                      >{{ translateUcFirst("justopp.deal.yourCurrentBid") }}:
                    </strong>
                    <span>
                      {{
                        translateNumber(currentUserBid.amount, "currency", {
                          currency: product.currency,
                        })
                      }}
                      / {{ translateUcFirst("justopp.deal.unit") }}
                    </span>
                  </div>
                  <icon-text
                    v-if="isUserWinningTheBid"
                    class="c-success text-l"
                    icon="check-circle">
                    {{ translateUcFirst("justopp.deal.yourBidIsWinning") }}
                  </icon-text>
                </div>
                <icon-text
                  icon="calendar"
                  class="expiration-clarification margin-l-top"
                  style="position: absolute; top: 100%; inset-inline-start: 0">
                  <span> {{ translateUcFirst("justopp.deal.expires") }}: </span
                  >&nbsp<strong>
                    {{ translateDate(product.AuctionProductType.endDateTime, "long") }}
                  </strong>
                </icon-text>
              </div>
            </div>
          </div>
        </div>

        <div class="aside">
          <div class="brand-intro border-gray-thin bg-gray-1 padding-s">
            <div class="brand-logo-name-container flex width-expand flex-center">
              <div class="brand-logo">
                <img :src="brand.logoImage" alt="brand logo" />
              </div>
              <!--     <h3 class="brand-name margin-remove text-bold">{{ product.brandName }}</h3>-->
            </div>
          </div>
          <div
            class="main-image border-gray-thin bg-gray-1 padding-s margin-m-bottom margin-m-top border-radius-s padding-s"
            style="width: 100%; height: 300px">
            <img
              v-if="currentProductImage"
              style="object-fit: contain; height: 100%; width: 100%; cursor: zoom-in"
              :src="currentProductImage?.url"
              :alt="currentProductImage?.description"
              @click="
                showLargeImage({
                  src: currentProductImage.url,
                  alt: currentProductImage.description,
                })
              " />
          </div>

          <div
            class="slider-container relative border-radius-s padding-s-vertical padding-m-horizontal border-gray-thin bg-gray-1">
            <div class="slider-wrapper-inner relative">
              <slider
                v-if="product.images"
                :navigation-outside="true"
                navigation-bg-theme="lead"
                navigation-theme="lead"
                navigation-theme-type="minimal"
                class="gallery padding-xl-horizontal"
                :config="mediaSliderConfig">
                <slide
                  v-for="(image, index) in product.images"
                  :key="index"
                  :class="{ highlight: image.url === currentProductImage?.url }"
                  class="image-thumb-slide cursor-pointer"
                  @click="currentProductImage = image">
                  <div
                    class="image-slide-inner border-radius-s padding-s flex-center"
                    style="height: 100%; width: 100%">
                    <img
                      style="object-fit: contain; height: 100%; width: 100%"
                      :src="image?.url"
                      :alt="image?.description" />
                  </div>
                </slide>
              </slider>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product-info-container flex gap-xl">
      <div class="content width-expand">
        <tabs :tabs="productTabs">
          <template #tab-brand>
            <div>
              <h3>{{ brand.name }}</h3>
              <content-blocks :content="brand.description"></content-blocks>
            </div>
          </template>
          <template #tab-product-info>
            <div>
              <h3>{{ translateUcFirst("justopp.deal.productInfo") }}</h3>
              <div class="product-information-content">
                <content-blocks :content="product.information"></content-blocks>
              </div>
            </div>
          </template>
          <template #tab-specs>
            <div>
              <h3>{{ translateTitleCase("justopp.deal.tabs.specificationTitle") }}</h3>
              <div class="spec-item">
                <div class="spec-item__label">
                  <span
                    >{{ translateUcFirst("justopp.deal.specs.packageDimensions") }}:</span
                  >
                </div>
                <div class="spec-item__value">
                  <span>
                    {{ product.packageWidth }} {{ packageSizeUnits }} X
                    {{ product.packageHeight }} {{ packageSizeUnits }} X
                    {{ product.packageDepth }} {{ packageSizeUnits }} (width x height x
                    depth)
                  </span>
                </div>
              </div>

              <div class="spec-item">
                <div class="spec-item__label">
                  <span>{{ translateUcFirst("justopp.deal.specs.productWeight") }}:</span>
                </div>
                <div class="spec-item__value">
                  <span> {{ product.weight }} {{ weightUnits }} </span>
                </div>
              </div>

              <div class="spec-item">
                <div class="spec-item__label">
                  <span>{{ translateUcFirst("justopp.deal.specs.Warranty") }}:</span>
                </div>
                <div class="spec-item__value">
                  <span>
                    {{ product.warranty }}
                  </span>
                </div>
              </div>
              <div class="spec-item">
                <div class="spec-item__label">
                  <span>{{ translateUcFirst("justopp.deal.specs.accessories") }}:</span>
                </div>
                <div class="spec-item__value">
                  <span>
                    {{ product.numAccessories }}
                  </span>
                </div>
              </div>
              <div class="spec-item">
                <div class="spec-item__label">
                  <span
                    >{{
                      translateUcFirst("justopp.deal.specs.accessoriesDescription")
                    }}:</span
                  >
                </div>
                <div class="spec-item__value max-width-800">
                  <p>
                    {{ product.accessoriesDescription }}
                  </p>
                </div>
              </div>
              <div class="spec-item">
                <div class="spec-item__label">
                  <span>{{ translateUcFirst("justopp.deal.specs.color") }}:</span>
                </div>
                <div class="spec-item__value">
                  <span>
                    {{ product.color }}
                  </span>
                </div>
              </div>
              <div class="spec-item">
                <div class="spec-item__label">
                  <span>{{ translateUcFirst("justopp.deal.specs.watts") }}:</span>
                </div>
                <div class="spec-item__value">
                  <span>
                    {{
                      product.watts !== ""
                        ? product.watts
                        : translate("justopp.deal.unknownStat")
                    }}
                  </span>
                </div>
              </div>
              <div class="spec-item">
                <div class="spec-item__label">
                  <span>{{ translateUcFirst("justopp.deal.specs.plug") }}:</span>
                </div>
                <div class="spec-item__value">
                  <span>
                    {{
                      product.plug !== ""
                        ? product.plug
                        : translate("justopp.deal.unknownStat")
                    }}
                  </span>
                </div>
              </div>

              <div class="spec-item">
                <div class="spec-item__label">
                  <span>{{ translateUcFirst("justopp.deal.specs.specFile") }}:</span>
                </div>
                <div class="spec-item__value">
                  <a v-if="product.specFile" :href="product.specFile" target="_blank">
                    <icon-text icon="cloud-download">
                      {{ translateUcFirst("justopp.general.download") }}
                    </icon-text>
                  </a>
                  <span v-else>{{ translate("justopp.deal.unknownStat") }}</span>
                </div>
              </div>
            </div>
          </template>
          <template #tab-files>
            <div>
              <div
                v-if="product.youtubeVideoId && product.youtubeVideoId != ''"
                class="margin-2xl-bottom">
                <h3 class="margin-s-bottom">
                  {{ translateTitleCase("justopp.deal.tabs.youtubeVideoTitle") }}
                </h3>
                <iframe
                  class="border-thin-gray padding-xs"
                  style="height: 300px; width: 450px; max-width: 100%"
                  :src="`https://www.youtube.com/embed/${product.youtubeVideoId}`"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen></iframe>

                <form-button
                  class="margin-m-top"
                  icon="clipboard"
                  text="justopp.deal.tabs.videoCopyCta"
                  theme="inverse"
                  @click="copyProductYoutubeVideoUrlToClipboard" />
                <div v-if="showVideoLinkText" class="video-link-text margin-m-top">
                  <strong>{{ tu("justopp.deal.tabs.VideoUrlLabel") }}</strong
                  >: <span>{{ product.videoUrl }}</span>
                </div>
              </div>

              <div
                v-if="product.videoUrl && product.videoUrl != ''"
                class="margin-2xl-bottom">
                <h3 class="margin-s-bottom">
                  {{ translateTitleCase("justopp.deal.tabs.videoTitle") }}
                </h3>
                <video style="height: 300px; width: 450px; max-width: 100%" controls>
                  <source :src="product.videoUrl" />
                </video>

                <form-button
                  class="margin-m-top"
                  icon="clipboard"
                  text="justopp.deal.tabs.videoCopyCta"
                  theme="inverse"
                  @click="copyProductVideoUrlToClipboard" />
                <div v-if="showVideoLinkText" class="video-link-text margin-m-top">
                  <strong>{{ tu("justopp.deal.tabs.VideoUrlLabel") }}</strong
                  >: <span>{{ product.videoUrl }}</span>
                </div>
              </div>

              <h3>{{ translateTitleCase("justopp.deal.tabs.downloadsTitle") }}</h3>
              <ul style="list-style: none">
                <li
                  v-if="product.specFile && product.specFile !== ''"
                  class="margin-l-bottom">
                  <a :href="product.specFile" target="_blank">
                    <icon-text icon="cloud-download">
                      {{ translateUcFirst("justopp.deal.specFile") }}
                    </icon-text>
                  </a>
                </li>
                <li v-for="file of product.productFiles" class="margin-l-bottom">
                  <a :href="file.fileUrl" target="_blank">
                    <icon-text icon="cloud-download">
                      {{
                        file.fileTitle && file.fileTitle != ""
                          ? file.fileTitle
                          : translate("justopp.deal.unknownFileName")
                      }}
                    </icon-text>
                  </a>
                </li>
              </ul>
            </div>
          </template>
          <template v-for="(val, index) of infoTabsSlotMap" #[val]="slotProps">
            <content-blocks
              :content="product.additionalInformation[index].content"></content-blocks>
          </template>
        </tabs>
      </div>
      <!--  <div class="aside l:visible width-expand" style="max-width:40%;"></div> -->
    </div>

    <modal
      :show="isShowingBidPlacer"
      size="l"
      title="justopp.bid.bidPlacerTitle"
      :show-footer="false"
      @modal:closed="isShowingBidPlacer = false">
      <bid-placer
        :product="product"
        @bid-placer:bid-placed="handleBidPlaced"></bid-placer>
    </modal>
    <large-image-modal
      :src="largeImageSrc"
      :show="isShowingLargeImage"
      :alt="largeImageAlt"
      @modal:closed="isShowingLargeImage = false">
    </large-image-modal>
  </block>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { reactive } from "vue";
import useCarts from "@/client/extensions/composition/useCarts.js";
import BidPlacer from "@/client/applications/justopp/components/ecommerce/BidPlacer";

export default {
  components: {
    BidPlacer,
  },
  layout: {
    component: "default",
    params: reactive({
      title: "justopp.deal.pageTitle",
      // subTitle: "justopp.deal.pageSubtitle",
    }),
  },
  middleware: {
  //  requireUser: {},
  },
  props: {
    dealId: {
      type: [String, Number],
      default: -1,
      required: true,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    let carts = useCarts(props);

    return { asyncOps, asyncOpsReady, asyncStatus, carts };
  },
  meta: {
    title: "justopp.deal.browserTitleGeneric",
  },
  data() {
    return {
      showVideoLinkText: false,
      isShowingBidPlacer: false,
      temp: true,
      product: false,
      quantity: 0,
      currentProductImage: false,
      mediaSliderConfig: {
        loop: false,
        slidesPerView: "auto",
        center: true,
        // spaceBetween: 20,
        breakpoints: {
          767: {
            // slidesPerView: 3,
          },
        },
        pagination: false,
        observer: true,
        observeParents: true,
        parallax: true,
        // Navigation arrows
        //   navigation: {
        //    nextEl: ".swiper-button-next",
        //    prevEl: ".swiper-button-prev",
        // },
      },
      largeImageSrc: "",
      largeImageAlt: "",
      isShowingLargeImage: false,
      asyncData: {
        product: {
          target: "justopp/deals/" + this.dealId,
          data: {},
          options: {
            errorHandler: "404", //"404",
            dataMutator: (input) => {
              // console.log('product', input.item);
              return input.item;
            },
          },
        },
      },
    };
  },
  computed: {
    brand() {
      if (!this.product) {
        return {
          name: "",
          description: {},
          logoImage: "",
        };
      }
      // if brand defined - show it, else , use product
      if (this.product.Brand && this.product.Brand.name != "") {
        return this.product.Brand;
      } else {
        return {
          name: this.product.brandName,
          description: this.product.brandInformation,
          logoImage: this.product.brandLogo,
        };
      }
    },
    hasEnded() {
      let endDate = this.product?.AuctionProductType?.endDateTime;

      if (!endDate) {
        return false;
      }

      let endTime = new Date(endDate).getTime();
      let now = new Date().getTime();
      let result = now > endTime;

      return result;
    },
    isBiddingEnabled() {
      if (!this.product) {
        return false;
      }

      if (!this.product.AuctionProductType) {
        return false;
      }

      return !!this.product.AuctionProductType.isBiddingEnabled;
    },
    infoTabsSlotMap() {
      let result = {};
      let i = 0;

      if (!this.product) {
        return result;
      }
      this.product.additionalInformation.forEach((info) => {
        result[i] = "tab-info-" + i;
        i++;
      });

      return result;
    },
    productTabs() {
      let result = [
        { id: "brand", label: "justopp.deal.tabs.brand" },
        { id: "product-info", label: "justopp.deal.tabs.productInfo" },
        { id: "specs", label: "justopp.deal.tabs.specification" },
      ];
      if (!this.product) {
        return result;
      }
      let hasFiles = this.product.productFiles && this.product.productFiles.length > 0;
      let hasYoutubeVideo =
        this.product.youtubeVideoId && this.product.youtubeVideoId != "";
      if (hasFiles || hasYoutubeVideo) {
        result.push({ id: "files", label: "justopp.deal.tabs.files" });
      }

      let i = 0;

      this.product.additionalInformation.forEach((info) => {
        result.push({
          id: "info-" + i,
          slotName: "tab-info-" + i,
          label: info.title,
          translate: false,
        });
        i++;
      });

      return result;
    },
    currentWinningBid() {
      if (!this.product) {
        return 0;
      }
      let bids = this.product?.AuctionProductType?.AuctionBids;

      if (!bids) {
        return false;
      }
      let min = 0;
      let winner = false;
      bids.forEach((bid) => {
        if (bid.amount > min) {
          min = bid.amount;
          winner = bid;
        }
      });

      return winner;
    },
    highestCurrentBid() {
      if (!this.product) {
        return 0;
      }
      let bids = this.product?.AuctionProductType?.AuctionBids;

      if (!bids) {
        return 0;
      }
      let min = 0;

      bids.forEach((bid) => {
        if (bid.amount > min) {
          min = bid.amount;
        }
      });

      return min;
    },
    isUserWinningTheBid() {
      if (!this.productHasAuction) {
        return false;
      }
      let bids = this.product?.AuctionProductType?.AuctionBids;
      if (!bids) {
        return false;
      }

      let userId = this.$store.getters["user/profile"]?.id;

      if (!userId) {
        return false;
      }

      let winningBid = this.currentWinningBid;
      if (winningBid.OwnerId == userId) {
        return true;
      }

      return false;
    },
    userHasBid() {
      if (!this.productHasAuction) {
        return false;
      }
      let userId = this.$store.getters["user/profile"]?.id;
      if (!userId) {
        return false;
      }

      let res = false;
      let bids = this.product?.AuctionProductType?.AuctionBids;

      if (!bids) {
        return false;
      }

      bids.map((bid) => {
        if (bid.OwnerId == userId) {
          res = true;
        }
      });
      return res;
    },
    productHasAuction() {
      return !!this.product?.AuctionProductType;
    },
    minimumBid() {
      if (!this.product) {
        return 0;
      }
      let min = this.product?.AuctionProductType?.startingPrice;

      if (!min) {
        return 0;
      }
      if (this.highestCurrentBid > min) {
        min = this.highestCurrentBid;
      }

      return min + config.justopp.auction.minBidIncrease;
    },
    currentUserBid() {
      let userId = this.$store.getters["user/profile"]?.id;
      if (!this.product) {
        return 0;
      }
      let bids = this.product?.AuctionProductType?.AuctionBids;

      if (!bids) {
        return false;
      }
      let min = 0;
      let targetBid = false;
      bids.forEach((bid) => {
        if (bid.amount > min && bid.OwnerId == userId) {
          min = bid.amount;
          targetBid = bid;
        }
      });

      return targetBid;
    },
    packageSizeUnits() {
      let defaultUnits = "cm";
      if (!this.product) {
        return defaultUnits;
      }
      return this.product.packageSizeUnits != ""
        ? this.product.packageSizeUnits
        : defaultUnits;
    },
    weightUnits() {
      let defaultUnits = "kg";
      if (!this.product) {
        return defaultUnits;
      }
      return this.product.packageSizeUnits != ""
        ? this.product.weightUnits
        : defaultUnits;
    },
  },
  watch: {
    product(newVal) {
      this.currentProductImage = newVal.images[0];
    },
  },
  methods: {
    async updateMetaByState() {
      try {
        this.meta.title = this.translate("justopp.deal.browserTitle", {
          productName: this.product.name,
        });

        this.quantity = this.product.JustoppDealProductType.maximumQuantity;
        //let layoutConf = this[config.layoutAccessorKey]();
        //layoutConf.params.title = "justopp.deal.pageTitle";
      } catch (e) {}
    },
    showLargeImage(props) {
      this.largeImageSrc = props.src;
      this.largeImageAlt = props.alt;
      this.isShowingLargeImage = true;
    },
    handleBidPlaced() {
      this.refreshAsyncData();
      this.isShowingBidPlacer = false;
    },
    async beginProductOrder(type) {
      if (type === "bid") {
        return false;
      }

      this.$s.ui.globalSpinner.show();
      let cart = await this.carts.getCart();
      await cart.empty();
      await this.carts.setDefaultCart(cart);

      //  cart =  await this.carts.getCart();
      let itemToAdd = {
        ProductId: this.product.id,
        quantity: this.quantity,
        productConfig: {
          justoppDeal: {},
          //  auction: {
          //bidId: null,
          //  },
        },
      };

      let addResult = await cart.addItem(itemToAdd);

      this.$s.ui.globalSpinner.hide();
      this.$router.push({ name: "store-checkout", params: { locale: this.locale } });
    },
    async copyProductYoutubeVideoUrlToClipboard() {
      try {
        await navigator.clipboard.writeText(
          `https://youtu.be/${this.product.youtubeVideoId}`
        );
        this.$s.ui.notification("justopp.deal.tabs.copiedToClipboardSuccess", "success");
      } catch (e) {
        this.$s.ui.notification("justopp.deal.tabs.copiedToClipboardError", "error");
        this.showVideoLinkAsText();
      }
    },
    async copyProductVideoUrlToClipboard() {
      try {
        await navigator.clipboard.writeText(this.product.videoUrl);
        this.$s.ui.notification("justopp.deal.tabs.copiedToClipboardSuccess", "success");
      } catch (e) {
        this.$s.ui.notification("justopp.deal.tabs.copiedToClipboardError", "error");
        this.showVideoLinkAsText();
      }
    },
    showVideoLinkAsText() {
      this.showVideoLinkText = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  // base product content margin
  $bpc-margin: var(--margin-xl);

  margin-bottom: var(--margin-max);

  .content {
    flex: 60%;
  }

  .title {
    .h1 {
      font-size: calc(var(--font-max) * 0.7);
      font-weight: 500;
    }
    margin-bottom: var(--margin-2xl);
  }

  .purchase-ui {
    min-height: 180px;
    margin-bottom: $bpc-margin;
  }

  .controls-block {
    @media (max-width: 767px) {
      flex-direction: column;
    }

    .quantity-controls {
      max-width: 150px;

      @media (max-width: 767px) {
        max-width: 100%;
      }
    }

    .button {
      @media (max-width: 767px) {
        max-width: 100%;
      }
    }
  }

  .purchase-information {
    margin-bottom: $bpc-margin;
  }

  @mixin product-mini-block {
    border: 1px-solid var(--c-gray-2);
    box-shadow: var(--box-shadow-2);
    position: relative;
    background: var(--c-gray-1);
    padding: var(--margin-l);
  }

  .product-information-content {
    @include product-mini-block;
  }

  .brand-info-block {
    @include product-mini-block;

    .brand-logo {
      max-width: 200px;
      margin-inline-end: var(--margin-m);

      img {
        max-width: 100%;
        max-height: 100px;
        object-fit: contain;
      }

      @media (max-width: 767px) {
        max-width: 120px;
      }
    }
  }

  .brand-intro {
    // @include product-mini-block;
    justify-content: center;
    text-align: center;

    .brand-logo-name-container {
      .brand-logo {
        flex: 50%;
        max-width: 50%;
        margin-inline-end: 0;
      }

      .brand-name {
        flex: 50%;
        text-align: center;
      }
    }
  }

  .brand-logo-name-container {
    .brand-logo {
      max-width: 200px;
      margin-inline-end: var(--margin-m);

      img {
        max-width: 100%;
        max-height: 100px;
        object-fit: contain;
      }

      @media (max-width: 767px) {
        max-width: 120px;
      }
    }
  }

  .brand-name {
    display: flex;
    align-items: center;
  }

  .aside {
    flex: 0 0 40%;
    max-width: 40%;

    @media (max-width: 1024px) {
      flex: 500px;
      flex-grow: 0;
      margin-inline: auto;
      align-self: center;
      max-width: 100%;
    }
  }

  .slider-wrapper-inner {
    width: fit-content;
    margin-inline: auto;
  }

  .gallery {
    height: 100px;
    border: 1px-solid var(--c-gray-2);
    box-shadow: var(--box-shadow-2);
    position: relative;
    background: var(--c-gray-1);
    padding: var(--margin-m);
    flex: 0 0 100%;
    gap: var(--margin-m);
    max-width: 100%;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;

    @media (max-width: 1025px) {
      flex: 0 0 400px;
      max-width: 100%;
      width: 400px;
      height: 400px;
      margin-inline: auto;
    }

    .gallery-image {
      height: 100%;
      width: 100%;
      object-fit: contain;
      flex: 70%;
      border: 1px solid var(--c-gray-1);
    }

    .thumbs {
      flex: 25%;
      padding-bottom: var(--margin-m);

      img {
        width: clamp(20%, 25%, calc(25% - 3 * var(--margin-m) / 2));
        object-fit: contain;
        border: 1px solid var(--c-gray-2);
      }
    }
  }

  .image-thumb-slide {
    max-height: 80px;
    max-width: 80px;

    &.highlight {
      .image-slide-inner {
        border: 1px solid var(--c-lead);
      }
    }
  }

  .image-slide-inner {
    height: 100px;
    max-width: 100px;
    flex: 100px;
    border: 1px solid transparent;
  }
}
.buy-controls {
  @media (max-width: 1024px) {
    justify-content: center;
  }
}
.bid-button-controls {
  min-width: 350px;
  display: flex;
  gap: var(--margin-m);
  padding-top: 26px;
  @media (max-width: 1024px) {
  }

  @media (max-width: 500px) {
    flex: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-top: 0;
  }
}

.expiration-clarification {
  @media (max-width: 500px) {
    position: relative !important;
    top: 0 !important;
    margin-top: var(--margin-xs) !important;
  }
}
.spec-item {
  display: block;
  margin-bottom: var(--margin-m);

  &:last-child {
    margin-bottom: 0;
  }

  &__label {
    font-weight: 600;
    width: 100%;
    display: block;
  }

  &__value {
    display: inline-block;
  }
}

.product-info-container {
}
</style>
<style lang="scss">
.gallery {
  --swiper-navigation-sides-offset: calc(var(--margin-m) * 1.4);
}
.gallery .swiper-pagination {
  background-color: var(--c-gray-5);
  color: var(--c-bg);
  padding-block: var(--margin-xs);
  max-width: calc(100% - (2 * var(--margin-m)));
  margin: auto;
  inset-inline-start: var(--margin-m);
  inser-inline-end: auto;
}

.amount-control {
  input {
    min-width: 0 !important;
    max-width: calc(200px - 20px) !important;
  }
}
</style>
